import React, { Component } from "react";
import classNames from "classnames";

export class RestrictedNotification extends Component {

  classNames() {
    return classNames(
      'ds-banner',
      '_alignCenter',
      '-warning',
      { _displayBlock: true },
    );
  }

  bodyClassNames() {
    let fontColor =
      this.notificationContent.className === '-warning' ? '-base' : '-inverted';
    return `copy emphasize ${fontColor}`;
  }

  renderContent(){
    return(
      <small className='subhead' data-testid='notification-header'>
        Your access to this screen is limited to 30 minutes. Please ensure that the client has provided you their consent before making a drawdown on their behalf.
      </small>
    );
  }

  render() {
    return (
      <div className={this.classNames()} data-testid='notification-container'>
        {this.renderContent()}
      </div>
    );
  }
}

export default RestrictedNotification;



// WEBPACK FOOTER //
// ./src/features/shared/containers/RestrictedNotification.js